export default {"src":"/_next/static/media/consumer_durables.f168a2de.svg","height":906,"width":767,"blurWidth":0,"blurHeight":0};